import { render, staticRenderFns } from "./GoodsVisitViewPanelLite.vue?vue&type=template&id=88602d22"
import script from "./GoodsVisitViewPanelLite.vue?vue&type=script&lang=js"
export * from "./GoodsVisitViewPanelLite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports